/* eslint-disable sonarjs/no-commented-code */
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Output,
  signal,
} from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NotificationService, type UserNotificationListDTO } from '@szebit-app/sdk/backend';
import { openErrorToast } from '@pct-ng/feature-message-material';
//import { of } from 'rxjs';
import { fadeIn2XFastEnter } from '@pct-ng/animation';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { finalize } from 'rxjs';

interface UserNotificationListExtendedDTO extends UserNotificationListDTO {
  loading: boolean;
}

@Component({
  selector: 'app-header',
  imports: [MatButtonModule, MatMenuModule, MatIconModule, MatProgressSpinner],
  providers: [NotificationService],
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block w-full h-full notifications-container',
  },
  animations: [fadeIn2XFastEnter],
})
export class NotificationComponent {
  readonly #service = inject(NotificationService);
  protected readonly loading = signal(true);
  protected notifications: UserNotificationListExtendedDTO[] | null = null;
  @Output() closeElement = new EventEmitter<void>();

  constructor() {
    this.#listUserNotifications();
  }

  #listUserNotifications(): void {
    /*const mockData: UserNotificationListDTO[] = [
      {
        notificationId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
        title: 'Mock értesítés',
        description: 'Mock értesítés leírása',
      },
      {
        notificationId: '3fa85f64-5717-4562-b3fc-2c963f66afa7',
        title: 'Mock értesítés Mock értesítés Mock értesítés',
        description: `Mock értesítés leírása Mock értesítés leírása Mock értesítés leírása Mock értesítés leírása Mock értesítés
          Mock értesítésMock értesítésMock értesítésMock értesítés`,
      },
      {
        notificationId: '3fa85f64-5717-4562-b3fc-2c963f66afa8',
        title: 'Rövid',
        description: 'Rövid',
      },
    ];*/
    //..of(mockData)..
    this.loading.set(true);

    this.#service
      .listUserNotifications()
      .pipe(finalize(() => this.loading.set(false)))
      .subscribe({
        next: data => {
          this.notifications = data.map(item => ({
            ...item,
            loading: false,
          }));
        },
        error: () => {
          openErrorToast({
            title: 'Értesítések',
            message: `Hiba a betöltés során`,
          });
        },
      });
  }

  protected deleteNotification(notification: UserNotificationListExtendedDTO): void {
    if (notification.loading) {
      return;
    }
    notification.loading = true;

    this.#service.deleteUserNotification(notification.notificationId).subscribe({
      next: () => {
        this.#listUserNotifications();
      },
      error: () => {
        notification.loading = false;
        openErrorToast({
          title: 'Értesítések',
          message: `Hiba a törlés során`,
        });
      },
    });
  }
}
